import React from 'react';
import {
  Layout,
  Modal,
  Icon,
} from 'antd';
import { connect } from 'react-redux';
import { handleExitToken } from '../../../utils/LoginToken';
import s from './style.less';

const { content } = Layout;
const confirm = Modal.confirm;


const mapStateToProps = (state) => ({
  loginStatus: state.root.loginStatus,
  loginData: state.root.loginData,
});

const UnLoginedView = () => (
  <content className={s.wrap}>
    <a href="https://www.99bill.com">快钱首页</a>
    {/* <a href="https://help.99bill.com/index.php/qiye.html">帮助中心</a> */}
    <a href="https://www.99bill.com/website/myaccount/myacctinfo.htm">切换旧版</a>
  </content>
);

const TopBar = (props) => {
  const exitWebsite = () => {
    confirm({
      title: '确认退出当前账号？',
      okText: '确定',
      onOk() {
        handleExitToken();
      },
      cancelText: '取消',
      onCancel() { },
    });
  };

  return props.loginStatus === 1 ? (
    <content className={s.wrap}>
      <a href="https://www.99bill.com">快钱首页</a>
      <a href="https://www.99bill.com/website/myaccount/myacctinfo.htm">切换旧版</a>
      <span className={s.userName}>
        欢迎您，{props.loginData.merchantBaseInfo.memberAccount || ''}
        <Icon className={s.userNameArrowD} type="down" theme="outlined" />
        <div className={s.userNameBox}>
          <a onClick={exitWebsite}>退出登录</a>
        </div>
      </span>
      {/* <a style={{ color: '#f54d4f' }} onClick={exitWebsite}>退出</a>| */}
    </content>
  ) : <UnLoginedView />;
};

export default connect(mapStateToProps)(TopBar);



// WEBPACK FOOTER //
// ./src/views/MainLayout/TopBar/TopBar.jsx